import { render } from "./PlantTable.vue?vue&type=template&id=b94c41c0&scoped=true"
import script from "./PlantTable.vue?vue&type=script&lang=js"
export * from "./PlantTable.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b94c41c0"

export default script